export default "__VITE_ASSET__t3BF3g5Z__"